function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "twitter");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-347.000000, -99.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(170.000000, 99.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(177.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21,0 C32.5979797,0 42,9.40202025 42,21 C42,32.5979797 32.5979797,42 21,42 C9.40202025,42 0,32.5979797 0,21 C0,9.40202025 9.40202025,0 21,0 Z M32.2807807,12 L30.1247914,13.4578602 L29.7059421,13.6717024 C28.8482188,12.6568008 27.5916709,12 26.1715882,12 C23.5917435,12 21.4991656,13.7582575 21.4991656,16.3752779 C21.4991656,16.7316815 21.5458899,17.4393971 21.6193136,17.7737376 L21.6193136,17.7737376 L21.4991656,17.8348353 C21.4991656,17.8348353 12.1559893,16.3752779 11.4384387,12.7297787 C11.4384387,12.7297787 9.28078067,16.3752779 12.8752086,19.2926956 C12.8752086,19.2926956 11.4384387,20.0224743 10.7192193,19.2926956 C10.7192193,19.2926956 10.7192193,21.4803345 14.3119785,23.6679735 C14.3119785,23.6679735 12.8752086,24.3977522 12.1559893,23.6679735 L12.159,23.671 L12.2328624,23.7446523 C12.6823769,24.1888605 14.9964324,26.4178338 16.3260923,26.5764795 L16.4696365,26.5853911 C16.4696365,26.5853911 16.4696365,28.7730301 10,28.7730301 C10,28.7730301 18.1784082,34.2395817 25.8128129,28.0432514 C29.694261,24.8933228 30.6387579,20.9033002 30.6888196,17.8925387 C30.7805993,17.5208608 30.8440107,17.1389998 30.8440107,16.7401673 L30.8440107,16.7401673 L30.8440107,16.3752779 L33,14.187639 L30.8440107,14.9174177 L32.2807807,12 Z"
}))))));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.7535b93c.svg";
export { ForwardRef as ReactComponent };